import { render, staticRenderFns } from "./VMultiselect.vue?vue&type=template&id=1b4e2fe0&lang=pug&"
import script from "./VMultiselect.vue?vue&type=script&lang=js&"
export * from "./VMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./VMultiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports